import * as React from 'react';
import './style.css';

export interface AuthHeadingProps {
  /* empty */
}

export interface AuthHeadingState {
  /* empty */
}

export class AuthHeading extends React.Component<
  AuthHeadingProps,
  AuthHeadingState
> {
  render() {
    return <h1 className="auth-heading">{this.props.children}</h1>;
  }
}

export default AuthHeading;



// WEBPACK FOOTER //
// ./src/app/components/Auth/AuthHeading/index.tsx